import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ButtonLoader } from '../../../../core';
import { ClienteFilter } from '../filter';
import { ClienteReportService } from '../services';

@Component({
    selector: 'sgt-cliente-listagem-report-modal',
    templateUrl: './cliente-listagem-report-modal.component.html',
    styleUrls: ['./cliente-listagem-report-modal.component.less']
})
export class ClienteListagemReportModalComponent implements OnInit {
    elModal: any;
    @ViewChild('form') form: NgForm;
    nomeImpressao: string;
    private filter: ClienteFilter;
    private orderBy: number;
    private orderByDir: string;

    constructor(private el: ElementRef,
                private clienteReportService: ClienteReportService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#nomeImpressao').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(filter: ClienteFilter, orderBy: number, orderByDir: string) {
        this.nomeImpressao = null;
        this.filter = filter;
        this.orderBy = orderBy;
        this.orderByDir = orderByDir;

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Realiza a impressão da listagem dos clientes */
    print() {
        const btnPrintListagem = new ButtonLoader('#btnPrintListagem');
        btnPrintListagem.loading('Imprimindo');
        this.clienteReportService.printListagem(this.nomeImpressao, this.filter, this.orderBy, this.orderByDir)
            .then(() => {
                btnPrintListagem.reset();
                this.close();
            })
            .catch(() => btnPrintListagem.reset());
    }
}
